// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-section-content{
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
}
.row-info-general-section{
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    align-items: center;
}
.rigth-content-row-general-section{
    position: relative;
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.left-content-row-general-section{
    position: relative;
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.rigth-content-row-general-section input{
    width: 100%;
    font-size: 12px;
    color: #636363;
}
.rigth-content-row-general-section button{
    width: 15vh;
    height: 3vh !important;
    font-size: 12px;
    color: #636363;

}
.rigth-content-row-general-section .compactAction{
justify-content: right;
}
.rigth-content-row-general-section .icon{
   fill: aliceblue;
   fill: aliceblue;
  z-index: 2;
  left: 2rem;
}
.rigth-content-row-general-section .inputSearch{
    width: 80%;
    height: 80%;
    left: 10%;
    position: relative;
    background-color: #003757;
    color: aliceblue;
}
.txt-left-row-general-section{
    color: #003757;
}
.cont-group-elements-general-section{
    position: relative;
    border: 1px solid #636363;
    border-radius: 10px;
    width: 95%;
    height: 90%;
}
.top-cont-group-elements-general-section{
    width: 100%;
    height: 40%;
    display: flex;
    justify-content: start;
    align-items: center;
}
.bottom-cont-group-elements-general-section{
    width: 100%;
    height: 60%;
    display: flex;
    justify-content: start;
    align-items: center;
    overflow-x: auto; 
}
.glob-info-element-general-section{
    position: relative;
    height: 70%;
    min-width: 25%;
    width: auto;
    border-radius: 30px;
    background-color: #e3e3e3;
    margin: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: small;
    color: #636363;
    
}
.close-globe-element{
    position: absolute;
    right: 4%;
    width: 15px;
    top:25%;
    /* padding-left: 2%;
    padding-right: 5%; */
}
.close-globe-element:hover{
cursor: pointer;
width: 16px;
}
.txt-globe-element{
   width: 80%;
}
.textArea-elements-general-section{
    width: 100%;
    height: 100%;
    border: none;
    resize: none;
    border-radius:10px;
}
.cell-row-info-general-section{
    width: 50%;
    height: 50%;
    position: relative;
    display: flex;
}
.rigth-content-row-general-section .menuSearchOption{
    width: 70%;
}
.rigth-content-row-general-section .checkbox-cis{
width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/hostManage-components/sections/styles/GeneralSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,cAAc;;AAElB;AACA;AACA,sBAAsB;AACtB;AACA;GACG,eAAe;GACf,eAAe;EAChB,UAAU;EACV,UAAU;AACZ;AACA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,OAAO;IACP;wBACoB;AACxB;AACA;AACA,eAAe;AACf,WAAW;AACX;AACA;GACG,UAAU;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;AACA,UAAU;AACV","sourcesContent":[".general-section-content{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n.row-info-general-section{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.rigth-content-row-general-section{\r\n    position: relative;\r\n    width: 80%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.left-content-row-general-section{\r\n    position: relative;\r\n    width: 20%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.rigth-content-row-general-section input{\r\n    width: 100%;\r\n    font-size: 12px;\r\n    color: #636363;\r\n}\r\n.rigth-content-row-general-section button{\r\n    width: 15vh;\r\n    height: 3vh !important;\r\n    font-size: 12px;\r\n    color: #636363;\r\n\r\n}\r\n.rigth-content-row-general-section .compactAction{\r\njustify-content: right;\r\n}\r\n.rigth-content-row-general-section .icon{\r\n   fill: aliceblue;\r\n   fill: aliceblue;\r\n  z-index: 2;\r\n  left: 2rem;\r\n}\r\n.rigth-content-row-general-section .inputSearch{\r\n    width: 80%;\r\n    height: 80%;\r\n    left: 10%;\r\n    position: relative;\r\n    background-color: #003757;\r\n    color: aliceblue;\r\n}\r\n.txt-left-row-general-section{\r\n    color: #003757;\r\n}\r\n.cont-group-elements-general-section{\r\n    position: relative;\r\n    border: 1px solid #636363;\r\n    border-radius: 10px;\r\n    width: 95%;\r\n    height: 90%;\r\n}\r\n.top-cont-group-elements-general-section{\r\n    width: 100%;\r\n    height: 40%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n.bottom-cont-group-elements-general-section{\r\n    width: 100%;\r\n    height: 60%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    overflow-x: auto; \r\n}\r\n.glob-info-element-general-section{\r\n    position: relative;\r\n    height: 70%;\r\n    min-width: 25%;\r\n    width: auto;\r\n    border-radius: 30px;\r\n    background-color: #e3e3e3;\r\n    margin: 2%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: small;\r\n    color: #636363;\r\n    \r\n}\r\n.close-globe-element{\r\n    position: absolute;\r\n    right: 4%;\r\n    width: 15px;\r\n    top:25%;\r\n    /* padding-left: 2%;\r\n    padding-right: 5%; */\r\n}\r\n.close-globe-element:hover{\r\ncursor: pointer;\r\nwidth: 16px;\r\n}\r\n.txt-globe-element{\r\n   width: 80%;\r\n}\r\n.textArea-elements-general-section{\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    resize: none;\r\n    border-radius:10px;\r\n}\r\n.cell-row-info-general-section{\r\n    width: 50%;\r\n    height: 50%;\r\n    position: relative;\r\n    display: flex;\r\n}\r\n.rigth-content-row-general-section .menuSearchOption{\r\n    width: 70%;\r\n}\r\n.rigth-content-row-general-section .checkbox-cis{\r\nwidth: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
